import { useMutation, useQueryClient } from '@tanstack/vue-query'
import { getApi } from '../api'

/** Geofences reference the type by id, so they follow a rename or a new parent untouched. */
export default () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({
      accountId,
      id,
      name,
      parent,
    }: {
      accountId: number
      id: number
      name?: string
      parent?: string
    }) => {
      const { api, baseURL } = getApi()
      return api
        .put(
          `/api/v2/accounts/${accountId}/place-types/${id}`,
          { name, parent },
          { baseURL },
        )
        .then((res) => res.data.data)
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['account-place-types'] })
    },
  })
}
